import { Link } from "react-router-dom";
import { axios } from "../../utils/axios";
import { toast } from "react-toastify";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Button } from "react-bootstrap";
import { toastOptions } from "../../config/toast";

export const getRecibosPagos = async (submittedData, setRecibosPagos, setMontoTotal, setError, setIsLoading) => {
  let start = new Date(submittedData.fecha_ini);
  var end = new Date(submittedData.fecha_fin);
  if (start > end) {
    setError("fecha_ini", { type: "dateComparison", message: "La fecha de inicio no debe ser mayor que la fecha fin" });
    return;
  }
  setIsLoading(true);
  // console.log(submittedData);
  const result = await axios().post("/recibos_pagos", submittedData);
  // console.log(result);
  const { data, error } = result.data;
  if (data) {
    setRecibosPagos(data.recibosPagos);
    setMontoTotal(data.montoTotal.toLocaleString());
  }
  if (error) {
    toast.error(error /* toastOptions */);
  }
  setIsLoading(false);
};

const formatDateToYYYYDDMM = (date) => {
  return date.split("-").reverse().join("-");
};

export const formatRangeString = (fecha_ini, fecha_fin) => {
  let rango = "";
  // console.log(fecha_ini, fecha_fin);
  if (fecha_ini === "" && fecha_fin === "") {
    rango = "los últimos 30 dias";
  } else if (fecha_ini !== "" && fecha_fin === "") {
    rango = `los 30 dias posteriores al ${formatDateToYYYYDDMM(fecha_ini)}`;
  } else if (fecha_ini === "" && fecha_fin !== "") {
    rango = `los 30 dias previos al ${formatDateToYYYYDDMM(fecha_fin)}`;
  } else if (fecha_ini === fecha_fin) {
    rango = "histórico";
  } else if (fecha_ini !== "" && fecha_fin !== "") {
    rango = `entre el ${formatDateToYYYYDDMM(fecha_ini)} y el ${formatDateToYYYYDDMM(fecha_fin)}`;
  }
  return rango;
};

export const handleCheckQuitaScoring = async (recibo, setRecibosPagos, setIsLoadingCheckScoring) => {
  const result = await axios().post("/check_quita_scoring", {
    idRecibo: recibo?.id,
    idActa: recibo?.acta?.id,
  });

  const { data, error } = result.data;

  if (data) {
    setRecibosPagos((prevState) => {
      const filteredData = prevState.filter((reciboState) => reciboState.id !== recibo.id);
      const index = prevState.findIndex((reciboState) => reciboState.id === recibo.id);
      return [...filteredData.slice(0, index), data, ...filteredData.slice(index)];
    });
  }
  if (error) {
    console.log(error);
  }
};

export const recibosPagosTableData = (data, setSelectedRow, setRecibosPagos, setModalIsOpenn, ua) => {
  const columns = [
    { field: "id", headerName: "ID", hide: true },
    {
      field: "created_at",
      headerName: "Fecha de creación",
      minWidth: 175,
      flex: 1.3,
      renderCell: (params) => {
        const date = new Date(params.row.created_at);
        return <p className='mb-0'>{date.toLocaleString()}</p>;
      },
    },
    {
      field: "numero_recibo",
      headerName: "# Recibo",
      minWidth: 125,
      flex: 1,
    },
    {
      field: "acta_asociada",
      headerName: "Acta Asociada",
      minWidth: 125,
      flex: 1,
    },
    {
      field: "monto",
      headerName: "Monto",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "descuento",
      headerName: "Descuento",
      minWidth: 100,
      flex: 1,
    },
    /* {
      field: "estado",
      headerName: "Estado Acta",
      minWidth: 250,
      flex: 1,
      renderCell: (params) => {
        const fecha_pago = params.row.ultimo_recibo_generado?.fecha_pago;
        const vencio = params.row.ultimo_recibo_generado?.vencio;
        let alert = "alert ";
        let textContent = "";

        if (params.row.ultimo_recibo_generado) {
          if (fecha_pago) {
            const dateFechaPago = new Date(fecha_pago);
            alert += "alert-success";
            textContent = "Pagado - " + dateFechaPago.toLocaleDateString();
          } else if (!fecha_pago && !vencio) {
            alert += "alert-warning";
            textContent = "No Pagado";
          } else if (!fecha_pago && vencio) {
            alert += "alert-danger";
            textContent = "No Pagado - Vencido";
          }
        } else {
          alert += "alert-danger";
          textContent = "Sin Recibo";
        }
        return (
          <div className={"w-100 h-100 m-0 border-0 rounded-0 " + alert}>
            <p className='w-100 h-100 d-flex justify-content-center align-items-center fw-bold'>{textContent}</p>
          </div>
        );
      },
    }, */
    {
      field: "fecha_pago",
      headerName: "Fecha pago",
      minWidth: 100,
      flex: 1,
      renderCell: (params) => {
        const date = new Date(params.row.fecha_pago);
        return <p className='mb-0'>{date.toLocaleDateString("es-AR", { timeZone: "GMT" })}</p>;
      },
    },
    {
      field: "check_scoring",
      headerName: "Scoring",
      minWidth: 200,
      hide: !ua.hasPermission("recibosPagos.marcarQuitaDeScoring"),
      flex: 1,
      renderCell: (params) => {
        return (
          <>
            {ua.hasPermission("recibosPagos.marcarQuitaDeScoring") ? (
              <div className='d-flex'>
                {params.row?.acta?.check_scoring ? (
                  <p className='mb-0'>Descontado</p>
                ) : (
                  <>
                    <Button style={{ fontSize: "14px" }} onClick={() => handleCheckQuitaScoring(params.row, setRecibosPagos)}>
                      Marcar como descontado
                    </Button>
                  </>
                )}
              </div>
            ) : null}
          </>
        );
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      minWidth: 200,
      flex: 2,
      renderCell: (params) => {
        return (
          <button
            id='botonVerRecibo'
            style={{ color: "#1334C9" }}
            onClick={() => {
              setSelectedRow(params.row);
              setModalIsOpenn(true);
            }}
          >
            <VisibilityIcon /> Ver
          </button>
        );
      },
    },
  ];

  const rows = data.map((d, index) => {
    return {
      id: d.id,
      acta_asociada: d.acta.dependencia + "-" + d.acta.numero_acta,
      numero_recibo: d.numero_recibo,
      monto: d.monto,
      descuento: d.descuento,
      fecha_vencimiento: d.fecha_vencimiento,
      fecha_pago: d.fecha_pago,
      vencio: d.vencio,
      check_scoring: d.acta.check_scoring,
      acta: d.acta,
      articulos: d.articulos,
      created_at: d.created_at,
      updated_at: d.updated_at,
    };
  });

  const filter = (d, value) => {
    value = value.toLowerCase();
    return (
      String(d.numero_recibo)?.toString().toLowerCase().includes(value) || String(d.acta_asociada)?.toLowerCase().includes(value) || String(d.monto)?.toLowerCase().includes(value) || String(d.fecha_vencimiento)?.toLowerCase().includes(value) || String(d.fecha_pago)?.toLowerCase().includes(value)
    );
  };

  return { columns, rows, filter };
};

export const getRecibo = async (numero_recibo, setReciboFisico, setIsLoading) => {
  setIsLoading(true);
  const result = await axios().post(`/obtener_recibo_backoffice`, {numero_recibo});
  const { data, error } = result.data;
  if (!error && data) {
    setReciboFisico(data);
  } else {
    toast.error(error, toastOptions);
  }
  setIsLoading(false);
  return;
};
